var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IndumentariasComponent',{attrs:{"base":_vm.base,"esMovil":_vm.esMovil,"paso_activo":true,"indumentarias-seleccionadas":_vm.indumentariasSeleccionadas},on:{"terminado":_vm.terminar,"volver":_vm.volver}})
}
var staticRenderFns = []

export { render, staticRenderFns }